<template>
  <div class="talentq-test-item">
    <div class="title">{{ assessment.code.title }}</div>

    <vbutton
      v-if="assessment.status.id > 3"
      disabled
      :label="$tr('interview.landing.modules.shl-test.finish')"
    />

    <vbutton v-else :label="$tr('interview.tests.init.button.start')" @click="$emit('start')" />
  </div>
</template>

<script>
  export default {
    name: 'TalentqChoiceTestView',

    props: {
      assessment: {
        type: Object,
        required: true
      }
    }
  };
</script>

<style lang="scss" scoped>
  .talentq-test-item {
    margin: 20px 0;
    display: flex;
    align-items: center;
    padding: 10px 0;
    border-bottom: 1px solid #d7d7d7;

    .title {
      flex-grow: 1;
      text-align: center;
      font-size: 18px;
      margin: 10px 10px 10px 0;
    }
  }
</style>
